import { getInstance as getBootstrap } from 'utils/bootstrap';

/**
 * Determines if sessions registration step should be displayed based on conditions
 *
 * @param {boolean} isSessionRegistrationEnabled Whether the form session registartion is enabled
 * @param {boolean} allowSubmit Whether form submission is allowed (not in preview)
 * @param {Array} sessions Array of session objects
 * @param {boolean} isNotAttending Whether the user has answered as not attending to the event
 * @returns {boolean} Whether sessions registration step should be displayed
 */
export const shouldShowSessionRegistration = (
    isSessionRegistrationEnabled,
    allowSubmit,
    sessions = [],
    isNotAttending,
) => {
    const formSessionRegistrationFlagEnabled = getBootstrap().get('flags.formRegistrationForm', false);

    if (!formSessionRegistrationFlagEnabled || !isSessionRegistrationEnabled) {
        return false;
    }

    if (allowSubmit && isNotAttending) {
        return false;
    }

    if (!allowSubmit) {
        return true;
    }

    return sessions?.length > 0;
};
